import moment from 'moment'
import type { AncSchedulePreset } from '@type/antenatal.type'

/** Naegele: LMP + 280 days */
export function eddFromLmp(lmp: string): string {
  return moment(lmp, 'YYYY-MM-DD').add(280, 'days').format('YYYY-MM-DD')
}

export function gestationalAgeAt(lmp: string, onDate: string = moment().format('YYYY-MM-DD')) {
  const days = moment(onDate, 'YYYY-MM-DD').diff(moment(lmp, 'YYYY-MM-DD'), 'days')
  if (days < 0) return { weeks: 0, days: 0, label: '0w 0d' }
  const weeks = Math.floor(days / 7)
  const rem = days % 7
  return { weeks, days: rem, label: `${weeks}w ${rem}d` }
}

export type ScheduleContact = {
  visit_number: number
  contact_label: string
  /** Approximate gestational week when contact is due */
  due_week: number
}

const FOCUSED_4: ScheduleContact[] = [
  { visit_number: 1, contact_label: 'Booking / ANC1', due_week: 12 },
  { visit_number: 2, contact_label: 'ANC2', due_week: 26 },
  { visit_number: 3, contact_label: 'ANC3', due_week: 32 },
  { visit_number: 4, contact_label: 'ANC4', due_week: 36 }
]

const WHO_8: ScheduleContact[] = [
  { visit_number: 1, contact_label: 'Contact 1 (Booking)', due_week: 12 },
  { visit_number: 2, contact_label: 'Contact 2', due_week: 20 },
  { visit_number: 3, contact_label: 'Contact 3', due_week: 26 },
  { visit_number: 4, contact_label: 'Contact 4', due_week: 30 },
  { visit_number: 5, contact_label: 'Contact 5', due_week: 34 },
  { visit_number: 6, contact_label: 'Contact 6', due_week: 36 },
  { visit_number: 7, contact_label: 'Contact 7', due_week: 38 },
  { visit_number: 8, contact_label: 'Contact 8', due_week: 40 }
]

export function scheduleContacts(preset: AncSchedulePreset): ScheduleContact[] {
  if (preset === 'focused_4') return FOCUSED_4
  if (preset === 'who_8') return WHO_8
  return WHO_8
}

export function scheduledDateForContact(lmp: string, dueWeek: number): string {
  return moment(lmp, 'YYYY-MM-DD').add(dueWeek, 'weeks').format('YYYY-MM-DD')
}

export function nextAppointmentSuggestion(lmp: string, preset: AncSchedulePreset, afterVisitNumber: number): string {
  const contacts = scheduleContacts(preset)
  const next = contacts.find(c => c.visit_number === afterVisitNumber + 1) ?? contacts[contacts.length - 1]
  return scheduledDateForContact(lmp, next.due_week)
}
